module.exports = __webpack_public_path__ + "h5/img/Awardedtit.9a5c3706.png";